import { SearchBar } from 'components/searchBar';
import styles from './GoBackGameDetail.module.scss';
import { SlotCardType } from 'components/cards/slotCard';
import { Category } from 'types/categoryEnum';
import { useState } from 'react';
import { useGetLabelByKey, useGetLabelsByKeys } from 'hooks/useLingUI';
import { Icon, IconsEnum } from 'components/Icons';
import { useRouter } from 'next/router';

type GoBackGameDetailProps = {
  title: string;
  category: Category;
  cardChoseFromSnaiSlot: Array<SlotCardType>;
};

export const GoBackGameDetail = ({ title, category, cardChoseFromSnaiSlot }: GoBackGameDetailProps) => {
  const [isSearchOpened, setIsSearchOpened] = useState<boolean>(false);
  const router = useRouter();
  const [searchLabel, researchPlaceholder, goBackLabel] = useGetLabelsByKeys([
    'search',
    'search_placeholder',
    'indietro',
  ]);

  const handleChange = (state: boolean) => {
    setIsSearchOpened(state);
  };

  return (
    <div className={styles.container}>
      <button className={styles.buttonBack} onClick={() => router.back()} suppressHydrationWarning>
        <Icon iconId={IconsEnum.ARROW_BACK}></Icon>
        <span suppressHydrationWarning>{goBackLabel}</span>
      </button>
      <button
        type="button"
        onClick={() => setIsSearchOpened(true)}
        aria-label={IconsEnum.SEARCH}
        suppressHydrationWarning
        className={styles.buttonSearch}
      >
        <Icon iconId={IconsEnum.SEARCH} className={styles.iconSearch} color="var(--color-on-bg-primary)"></Icon>
        <span suppressHydrationWarning>{searchLabel}</span>
      </button>
      <SearchBar
        title={title}
        category={category || title}
        isMenuOpened={isSearchOpened}
        handleCloseMenu={handleChange}
        choseFromSnaiSlot={cardChoseFromSnaiSlot}
        inputPlaceholder={researchPlaceholder}
      />
    </div>
  );
};
